import React, { useState, useRef, useEffect } from "react";
import { Form, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { PhoneInput } from "react-international-phone";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../../../constants/index";
import FileUploader from "../../RecrtProcess/candidate/component/FileUploader";
import { useLocation, useParams } from "react-router-dom";
import Select from "react-select";
import moment from "moment";
import validate from "./validate";
import { FaSpinner } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

function ReferCandidate() {
  const navigate = useNavigate();
  const location = useLocation();
  const passedState = location.state;
  let minDob = moment().subtract(18, "years").format("DD-MMM-YYYY");
  let [errors, setErrors] = useState({});
  const { id } = useParams();
  const [fileName, setFileName] = useState([]);
  const [jobOptions, setJobOptions] = useState([]);
  const [skillsetOptions, setskillsetOptions] = useState([]);
  const [subSkillOptions, setsubSkillOptions] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [submitted, setSubmit] = useState(false);
  const [genderOptions, setGenderOption] = useState([]);
  const [resumeFile, setResumeFile] = useState([]);
  const [fileError, setFileError] = useState("");

  const initialFormData = {
    job_title: "",
    appliedDate: moment().format("DD-MMM-YYYY"),
    SkillSet: [],
    SubSkillSet: [],
    FirstName: "",
    LastName: "",
    FullName: "",
    Email: "",
    MobileNo: "",
    gender: "",
    DateOfBirth: minDob,
    otherDetails: "",
    ResumePath: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData((prevData) => ({ ...prevData, job_title: passedState?.JobMasterID }));
  }, [passedState]);
  const initialOpts = {
    value: 0,
    label: "",
  };
  const [defaultOption, setDefaultOption] = useState(initialOpts);

  const formRef = useRef(null);
  const handleChange = async (event) => {
    const { name, value } = event.target;

    // Update FormData state with the new value
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
      // If name is firstName or lastName, update fullName
      FullName:
        name === "FirstName"
          ? `${value} ${prevFormData.LastName}`
          : name === "LastName"
          ? `${prevFormData.FirstName} ${value}`
          : prevFormData.FullName,
    }));
    if (name === "MobileNo") {
      const error = await validate(name, value, formData, true);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  const handleDropdownChange = (e, name) => {
    //  const {  value,label } = e;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: e,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error if the field is being updated
    }));
  };

  const handleDateChange = (date, field) => {
    if (date) {
      const isoDate = moment(date).format("DD-MMM-YYYY");
      setFormData({
        ...formData,
        [field]: isoDate,
      });
    } else {
      setFormData({
        ...formData,
        [field]: "",
      });
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Refer a Candidate"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let mandatory_field = [
      "job_title",
      "SkillSet",
      "FirstName",
      "LastName",
      "gender",
      "Email",
      "MobileNo",
      "otherDetails",
    ];

    let isFormInvalid = false;

    for (let field of mandatory_field) {
      // Pass field directly, not as an array
      let error = await validate(field, formData[field], formData);

      if (error.status === true) {
        isFormInvalid = true;
        setErrors((errors) => ({
          ...errors,
          [field]: error,
        }));
      }
    }

    // Handle resume file validation
    if (resumeFile.length === 0 && !id) {
      setFileError(`Candidate resume required.`);
      // toast.error("Candidate resume is required.");
      return false;
    }

    if (!isFormInvalid) {
      setSubmit(true);
      try {
        const skillIDs = formData.SkillSet?.map((option) =>
          option?.value?.toString()
        ).join(",");
        const subskillsIDs = formData.SubSkillSet?.map((option) =>
          option?.value?.toString()
        ).join(",");

        const data = {
          ...formData,
          SkillSet: skillIDs,
          SubSkillSet: subskillsIDs,
          resumeFile: resumeFile,
        };

        let response;

        if (id) {
          response = await PostFormServiceCaller(
            `${API_URL}refercandidate/${id}`,
            data,
            "put"
          );
          toast.success(response.data);
          setSubmit(false);
          navigate("/my-refercandidate-status");
        } else {
          response = await PostFormServiceCaller(
            `${API_URL}refercandidate`,
            data,
            "post"
          );
        }

        if (response.data.status === "success") {
          toast.success(response.data.message);
          setSubmit(false);
          navigate("/my-refercandidate-status");
        } else {
          setSubmit(false);
          toast.error(response.data.message);
        }
      } catch (error) {
        setSubmit(false);
        console.error("Error submitting form data:", error);
        toast.error(
          "An error occurred while submitting the form. Please try again."
        );
      }
    }
  };

  // handle resume
  const handleFile = async (file) => {
    if (file) {
      const allowedExtensions = [".pdf", ".doc", ".docx"];
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(`.${fileExtension}`)) {
        setFileError("Only PDF and Word documents are allowed.");
        return;
      }

      if (file.size < 1048576) {
        setFileName(file.name);
        setFormData((prevState) => ({
          ...prevState,
        }));

        const url = `${API_URL}resume-upload`;
        const formFilePost = new FormData();
        setResumeFile(file);
        formFilePost.append("resume", file);
        formFilePost.append("fileName", file.name);
        setFormData((prevState) => ({
          ...prevState,
          ResumePath: file.name,
        }));
        setFileError("");
      } else {
        setFileError("File size should not be exceed than 1MB.");
      }
    }
  };
  const fetchData = async () => {
    try {
      //Fetch Data if edit form
      if (id) {
        // set subskills array
        const response = await GetServiceCaller(
          `${API_URL}refercandidate/${id}`
        );

        const job = response.data.referCandidate;

        if (job) {
          // setting dropdown data
          const jobData = response?.data?.jobTitle;
          const jobOptions = jobData?.map((job) => ({
            value: job.VALUE,
            label: job.TEXT,
          }));
          setJobOptions(jobOptions);
          //array for skills
          const skillsOpt = response.data.skillSet.map((option) => ({
            value: option.value,
            label: option.text,
          }));
          setskillsetOptions(skillsOpt);
          // set gender dropdown array
          const genderOpt = response.data.gender.map((option) => ({
            value: option.value,
            label: option.text,
          }));
          setGenderOption(genderOpt);
          // setting subskills
          const subSkillData = response.data.subskill;
          const options_subskills = subSkillData.map((subSkill) => ({
            value: subSkill.value,
            label: subSkill.label,
          }));
          //setting skills and subskills
          setsubSkillOptions(options_subskills);

          const {
            JobDescriptionID,
            JobTitle,
            AppliedDate,
            SkillSet,
            SubSkillSet,
            FirstName,
            LastName,
            FullName,
            EmailID,
            MobileNo,
            Gender_020,
            DateOfBirth,
            HowToKnow,
            ResumePath,
          } = job;
          //  selected job title
          let selectedJobTitle = jobOptions.find(
            (o) => o.value == JobDescriptionID
          );
          // selected Gender
          let selectedGender = genderOpt.find((o) => o.value == Gender_020);
          // selected skills
          let skill_selected = [];
          SkillSet?.split(",").forEach((element) => {
            skill_selected.push(
              skillsetOptions.find((o) => o.value == element)
            );
          });
          //sub skill selected
          let sub_skill_selected = [];
          SubSkillSet?.split(",").forEach((element) => {
            sub_skill_selected.push(
              options_subskills.find((o) => o.value == element)
            );
          });

          let selected_skills = [];
          let selected_subskilss = [];

          SkillSet?.split(",").forEach((element) => {
            let temp = skillsOpt.find((o) => o.value == element);
            if (temp) {
              selected_skills.push(temp);
            }
          });
          if (SubSkillSet) {
            SubSkillSet.split(",").forEach((element) => {
              let temp = response.data.subskill.find((o) => o.value == element);
              if (temp) {
                selected_subskilss.push(temp);
              }
            });
          }

          setDefaultOption({
            value: JobDescriptionID || "",
            label: JobTitle || "",
          });

          setFormData({
            job_title: selectedJobTitle,
            appliedDate: moment(AppliedDate).format("DD-MMM-YYYY") || "",
            SkillSet: selected_skills || "",
            SubSkillSet: selected_subskilss || "",
            FirstName: FirstName || "",
            LastName: LastName || "",
            FullName: FullName || "",
            Email: EmailID || "",
            MobileNo: MobileNo || "",
            gender: selectedGender || "",
            DateOfBirth: moment(DateOfBirth).format("DD-MMM-YYYY") || "",
            otherDetails: HowToKnow || "",
            ResumePath: ResumePath || "",
          });
        } else {
          console.error("Job not found with ID:", id);
        }
      } else {
        //calling a API for data
        const response3 = await GetServiceCaller(`${API_URL}refercandidate`); // Assuming the
        const jobData = response3?.data?.jobTitle;
        const jobOptions = jobData.map((job) => ({
          value: job.VALUE,
          label: job.TEXT,
        }));
        setJobOptions(jobOptions);
        //array for skills
        const skillsOpt = response3.data.skillSet.map((option) => ({
          value: option.value,
          label: option.text,
        }));
        setskillsetOptions(skillsOpt);
        // set gender dropdown array
        const genderOpt = response3.data.gender.map((option) => ({
          value: option.value,
          label: option.text,
        }));
        setGenderOption(genderOpt);
      }
      setPageLoading(false);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;

      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      // options.push(...subSkillOptions);
      setsubSkillOptions(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

  const handleSkillChange = async (selectedOption) => {
    // Update the SkillSet with the current selected options
    if (!selectedOption || selectedOption.length === 0) {
      setFormData({ ...formData, SkillSet: [] }); // Clear SkillSet if no options selected
    } else {
      setFormData({ ...formData, SkillSet: selectedOption }); // Update SkillSet with selected options
    }
    const error = validate("SkillSet", formData); // Validate after the change
    if (!error.status) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        SkillSet: null, // Clear the error for the SkillSet field
      }));
    }
  };

  useEffect(() => {
    if (formData.SkillSet?.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.SkillSet.map((option) => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(",");

      // Fetch sub-skill options with the comma-separated values
      fetchSubSkillOptions(skillValues);
    } else {
      setsubSkillOptions([]);
    }
  }, [formData.SkillSet]);

  const handleSubSkillChange = async (selectedOption) => {
    if (selectedOption.length == 0) {
      setFormData({ ...formData, SubSkillSet: [] });
    } else {
      let subSkill = selectedOption[selectedOption.length - 1];
      let subSkillSetArray = formData.SubSkillSet || [];
      if (subSkill?.value) {
        subSkillSetArray.push(subSkill);
      }
      setFormData({ ...formData, SubSkillSet: subSkillSetArray });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const handleOnTouch = async (e) => {
    const { name, value } = e.target;
    let error = await validate(name, value, formData);
    setErrors((errors) => ({
      ...errors,
      [name]: error,
    }));
  };

  const customStyle = {
    control: (provided, state) => ({
      ...provided,
      height: "80px",
      overflow: "scroll",
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      color: "white", // Sets the color of the cancel icon
      ":hover": {
        backgroundColor: "red", // Adjust hover background color if needed
        color: "white", // Adjust hover color here
      },
    }),
  };

  const handleCancel = () => navigate("/refer-candidate");

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="Container Support-Padding">
          <form ref={formRef} id="formOne" className="rounded mt-2 bg-white">
            <div className="container-fluid mt-2">
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <Form.Group
                      className="col-md-4 col-lg-3 col-form-label"
                      controlId="formName"
                    >
                      <Form.Label>
                        Job Title<span className="required">*</span>
                      </Form.Label>
                      <Select
                        name="job_title"
                        value={jobOptions?.find(
                          (item) => item.value == formData.job_title
                        )}
                        onChange={(selected) =>
                          handleDropdownChange(selected, "job_title")
                        }
                        options={jobOptions}
                      />
                      <span class="error">{errors?.job_title?.message}</span>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>Applied Date</Form.Label>
                      <div className=" ">
                        {/* <ReactDatePicker
                              minDate={new Date()}
                              autoComplete="off"
                              showPopperArrow
                              showIcon
                              icon="fa fa-calendar"
                              className="form-control"
                              placeholderText="Applied Date"
                              // format="DD-MM-YYYY"
                              name="appliedDate"
                              id="appliedDate"
                              dateFormat="DD-MMM-YYYY"
                              onChange={(date) =>
                                handleDateChange(date, "appliedDate")
                              }
                              value={formData.appliedDate}
                            /> */}
                        <CustomDatePicker
                          handleChange={(date) =>
                            handleDateChange(date, "appliedDate")
                          }
                          value={formData.appliedDate}
                          name="appliedDate"
                          id="appliedDate"
                          className="form-control"
                          placeholderText="Applied Date"
                          minDate={new Date()}
                        ></CustomDatePicker>
                      </div>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        {" "}
                        First Name<span style={{ color: "red" }}>*</span>{" "}
                      </Form.Label>
                      <div className=" ">
                        <Form.Control
                          type="text"
                          name="FirstName"
                          onChange={handleChange}
                          value={formData.FirstName}
                          onBlur={handleOnTouch}
                          placeholder="First Name"
                        />
                        <span class="error">{errors?.FirstName?.message}</span>
                      </div>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        {" "}
                        Last Name<span style={{ color: "red" }}>*</span>{" "}
                      </Form.Label>
                      <div className=" ">
                        <Form.Control
                          type="text"
                          name="LastName"
                          onChange={handleChange}
                          value={formData.LastName}
                          onBlur={handleOnTouch}
                          placeholder="Last Name"
                        />
                        <span class="error">{errors?.LastName?.message}</span>
                      </div>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        {" "}
                        Gender<span style={{ color: "red" }}>*</span>{" "}
                      </Form.Label>
                      <div className=" ">
                        <Select
                          name="gender"
                          value={formData.gender}
                          onChange={(selected) =>
                            handleDropdownChange(selected, "gender")
                          }
                          options={[
                            ...genderOptions,
                          ]}
                        />
                        <span class="error">{errors?.gender?.message}</span>
                      </div>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        {" "}
                        Email ID<span style={{ color: "red" }}>*</span>{" "}
                      </Form.Label>
                      <div className=" ">
                        <Form.Control
                          type="text"
                          name="Email"
                          onChange={handleChange}
                          value={formData.Email}
                          placeholder="Email ID"
                          onBlur={handleOnTouch}
                        />
                        <span class="error">{errors?.Email?.message}</span>
                      </div>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        {" "}
                        Contact No.<span style={{ color: "red" }}>*</span>{" "}
                      </Form.Label>
                      <div className="">
                        <input
                          className="form-control"
                          name="MobileNo"
                          value={formData?.MobileNo?.toString() || ""}
                          onChange={handleChange}
                          placeholder="Contact No."
                          maxLength="10"
                          type="tel"
                          pattern="[0-9]{10}"
                          inputMode="numeric"
                        />

                        <span class="error">{errors?.MobileNo?.message}</span>
                      </div>
                    </Form.Group>

                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-sm-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>DOB</Form.Label>
                      <div className="">
                        <CustomDatePicker
                          handleChange={handleChange}
                          value={formData.DateOfBirth}
                          name="DateOfBirth"
                          id="DateOfBirth"
                          className="form-control"
                          placeholderText="Date Of Birth"
                          maxDate={new Date()}
                        ></CustomDatePicker>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="row">
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>
                        Skill Set<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Select
                        menuShouldScrollIntoView={true}
                        isMulti
                        isClearable={true}
                        name="SkillSet"
                        options={[
                          ...skillsetOptions,
                        ]}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        styles={customStyle}
                        value={formData.SkillSet}
                        onChange={(selectedOptions) =>
                          handleSkillChange(selectedOptions)
                        }
                        // onChange={(selectedOptions) =>
                        //   setFormData({
                        //     ...formData,
                        //     SkillSet: selectedOptions,
                        //   })
                        // }
                        // onChange={}
                        // value={[{value:3,label:'Informatica'},{value:1,label:'MicroStrategy'}]}
                        // setValue={skillset}
                        // value={formData.SkillSet}
                      />
                      <span className="error">{errors?.SkillSet?.message}</span>
                    </Form.Group>
                    <Form.Group
                      as={Col}
                      xs={12}
                      className="col-md-4 col-lg-3 col-form-label"
                    >
                      <Form.Label>SubSkill Set</Form.Label>
                      <div className=" ">
                        <Select
                          menuShouldScrollIntoView={true}
                          isMulti
                          name="SubSkillSet"
                          styles={customStyle}
                          options={[
                            ...subSkillOptions,
                          ]}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          value={formData.SubSkillSet}
                          // onChange={(selectedOptions) => handleSubSkillChange(selectedOptions)}
                          onChange={(selectedOptions) =>
                            setFormData({
                              ...formData,
                              SubSkillSet: selectedOptions,
                            })
                          }
                        />
                      </div>
                    </Form.Group>
                    <div className="col-sm-6">
                      <Form.Group>
                        <Form.Label>
                          How are you Acquainted?
                          <span style={{ color: "red" }}>*</span>
                        </Form.Label>

                        <Form.Control
                          as="textarea"
                          name="otherDetails"
                          rows={3}
                          value={formData.otherDetails}
                          onChange={handleChange}
                          onBlur={handleOnTouch}
                        ></Form.Control>
                        <span class="error">
                          {errors?.otherDetails?.message}
                        </span>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-end">
                      <div>
                        <FileUploader handleFile={handleFile} />
                      </div>
                      <div>
                        {formData.ResumePath ? (
                          <p> {formData.ResumePath}</p>
                        ) : null}
                      </div>
                      <span className="error">{fileError}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2 mb-2">
              <div className="text-end">
                <button className="cancel-btn me-2" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  disabled={submitted ? true : false}
                  onClick={handleSubmit}
                  type=""
                  className="custom-btn"
                >
                  {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default ReferCandidate;
